import { defineComponent as _defineComponent } from 'vue'
import { watchEffect, ref, nextTick } from "../../../../adapter-vue";
import {
  TUITranslateService,
  IMessageModel,
} from "@tencentcloud/chat-uikit-engine";
import { isUrl, JSONToObject } from "../../../../utils/index";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { ICustomMessagePayload } from "../../../../interface";
import { isPC } from "../../../../utils/env";
import Dialog from "../../../common/Dialog/index.vue";
import Icon from "../../../common/Icon.vue";
import star from "../../../../assets/icon/star-light.png";
import sendSteps from "@/components/xypComponents/sendSteps.vue";
import PdfPreview from "@/components/PdfPreview.vue";
interface Props {
  messageItem: IMessageModel;
  content: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'message-custom',
  props: {
    messageItem: { default: undefined },
    content: { default: undefined }
  },
  emits: ["MessageCustomshow"],
  setup(__props: any, { emit: emits }) {

const props = __props as { messageItem: IMessageModel, content: any }




const custom = ref();
const message = ref<IMessageModel>();
const extension = ref();
const sendStepsRef = ref();
const pdfPreviewRef = ref();
const customData = ref<ICustomMessagePayload>({
  businessID: "",
  extension: "",
});

watchEffect(() => {
  custom.value = props.content;
  message.value = props.messageItem;
  const { payload } = props.messageItem;
  customData.value = payload.data || "";
  customData.value = JSONToObject(payload.data);
  if (payload.data === CHAT_MSG_CUSTOM_TYPE.SERVICE) {
    extension.value = JSONToObject(payload.extension);
  }
});
const openLink = (url: any) => {
  window.open(url);
};
function closeoutDialogShow() {
  // 如果是附件简历（down_type == 2），使用 PdfPreview 预览
  if (customData.value.down_type == 2) {
    pdfPreviewRef.value?.open({
      url: customData.value.attach_path,
      name: customData.value.resume_name
    });
  } else {
    // 在线简历，走原有逻辑
    let { conversationID = "" } = message.value;
    emits("MessageCustomshow", conversationID);
  }
}
const handleManage = () => {
  outDialogShow.value = false;
};
const viewSteps = () =>{
  sendStepsRef.value?.toggle(true);
  sendStepsRef.value?.getdetails({...customData.value});
}

return { __sfc: true,emits, props, custom, message, extension, sendStepsRef, pdfPreviewRef, customData, openLink, closeoutDialogShow, handleManage, viewSteps, TUITranslateService, isUrl, CHAT_MSG_CUSTOM_TYPE, Icon, star, sendSteps, PdfPreview }
}

})